import { render, staticRenderFns } from "./newpriceLK.vue?vue&type=template&id=7212b836&scoped=true"
import script from "./newpriceLK.vue?vue&type=script&lang=js"
export * from "./newpriceLK.vue?vue&type=script&lang=js"
import style0 from "./newpriceLK.vue?vue&type=style&index=0&id=7212b836&prod&scoped=true&lang=css"
import style1 from "./newpriceLK.vue?vue&type=style&index=1&id=7212b836&prod&lang=css"
import style2 from "./newpriceLK.vue?vue&type=style&index=2&id=7212b836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212b836",
  null
  
)

export default component.exports